"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionItemContent = exports.AccordionItemHeader = exports.AccordionItemContainer = exports.AccordionContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _architectMixins = require("@wealthmigrate/architect-mixins");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-CONTAINERS [ ACCORDION > STYLE ] ##################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. STYLES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. ACCORDION CONTAINER ....................................................


var AccordionContainer = _styledComponents["default"].div.withConfig({
  displayName: "indexstyle__AccordionContainer",
  componentId: "sc-1bfkygz-0"
})(["margin:0;padding:0;flex:none;width:100%;list-style:none;text-align:left;", ""], function (_ref) {
  var hasBorder = _ref.hasBorder;
  return hasBorder ? 'padding: var(--gutter-small); border: solid 1px var(--color); border-radius: var(--radius-small)' : null;
}); // 3.1. END ....................................................................
// 3.2. ACCORDION ITEM CONTAINER ...............................................


exports.AccordionContainer = AccordionContainer;

var AccordionItemContainer = _styledComponents["default"].div.withConfig({
  displayName: "indexstyle__AccordionItemContainer",
  componentId: "sc-1bfkygz-1"
})(["position:relative;border:solid 1px var(--color-light);border-radius:var(--radius-small);padding:var(--gutter-small);margin-bottom:var(--gutter-small);"]); // 3.2. END ....................................................................
// 3.3.ACCORDION ITEM HEADER ...................................................


exports.AccordionItemContainer = AccordionItemContainer;

var AccordionItemHeader = _styledComponents["default"].button.withConfig({
  displayName: "indexstyle__AccordionItemHeader",
  componentId: "sc-1bfkygz-2"
})(["display:flex;align-items:center;justify-content:space-between;margin:0;padding:0;width:100%;border:none;background:transparent;h4{margin:0;", ";font-family:var(--family-secondary) !important;transition:color var(--transition-fast);}svg{transition:var(--transition-fast);path{transition:fill var(--transition-fast);}}&:focus{outline:none;}&:hover{cursor:pointer;border-color:var(--color-darker);svg{path{fill:var(--color-accent);}}h4{color:var(--color-accent)!important;}}", ";"], (0, _architectMixins._mixin_font_size)('medium'), function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen && "\n      h4 {\n        color: var(--color-secondary)!important;\n      }\n      svg {\n        transform: rotate(45deg);\n\n        path {\n          fill: var(--color-secondary) !important;\n        }\n      }\n      ";
}); // 3.3. END ....................................................................
// 3.4. ACCORDION CONTENT ......................................................


exports.AccordionItemHeader = AccordionItemHeader;

var AccordionItemContent = _styledComponents["default"].div.withConfig({
  displayName: "indexstyle__AccordionItemContent",
  componentId: "sc-1bfkygz-3"
})(["opacity:0;position:absolute !important;transform:scale(0);pointer-event:none;transition:opacity var(--transition-fast);", " ", ";"], (0, _architectMixins._mixin_arrow)('top', 'var(--color-white)'), function (_ref3) {
  var isOpen = _ref3.isOpen;
  return isOpen && "\n      opacity: 1;\n      position: relative !important;\n      top: var(--gutter);\n      transform: scale(1);\n      pointer-event: auto;\n      padding: var(--gutter);\n      background: var(--color-white);\n      margin: var(--gutter-small) 0 var(--gutter);\n      color: var(--color-secondary);\n   ";
}); // 3.4. END  ...................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports.AccordionItemContent = AccordionItemContent;